<template>
  <b-modal
    id="addToJDSuccessSingle"
    no-close-on-backdrop
    size="md"
    centered
    hide-header
    hide-footer
    :visible="showAddToJDSuccessSingle"
    @shown="addSingleCandToJD"
    @hidden="clearSingleCandToJD"
  >
    <div class="cs-modal-header">
      <div>Add Candidate to Job</div>
      <div>
        <img
          class="rotate-on-hover"
          src="../../assets/img/accessconnew/blueCross.svg"
          alt=""
          @click="clearSingleCandToJD"
        />
      </div>
    </div>

    <div class="tp-modal-overflow-2">
      <b-row>
        <b-col cols="12">
          <div
            class="
              tp-add-cand-left
              d-flex
              align-items-center
              justify-content-between
              w-100
            "
          >
            <div class="ct-table-bold-txt-3 w-50 text-truncate">
              {{ singleCandidateJDResponse.name }}
            </div>
            <div
              class="tp-text-1 d-flex justify-content-end w-50 text-truncate"
            >
              {{ singleCandidateJDResponse.email }}
            </div>
          </div>
          <hr />
          <div class="tp-add-cand-left">
            <div class="d-flex align-items-center justify-content-between">
              <div class="ct-table-bold-txt-3">Job Details</div>
              <div class="ct-table-bold-txt-3">
                Total Job(s):
                <span>
                  {{
                    singleCandidateJDResponse.success.length +
                    singleCandidateJDResponse.failed.length
                  }}
                </span>
              </div>
            </div>

            <div
              class="tp-side-modal-card-red mt-3"
              v-if="singleCandidateJDResponse.failed.length !== 0"
            >
              <div class="ct-table-bold-txt-4">Already Existing</div>
              <div class="tp-text-1">
                This Candidate has already been added to these jobs
              </div>

              <div
                class="tp-second-modal-white-box mt-2"
                :key="i"
                v-for="(job, i) in singleCandidateJDResponse.failed"
              >
                <div
                  class="
                    d-flex
                    align-items-center
                    p-2
                    tp-below-text
                    defaultCursor
                  "
                >
                  <div class="ellipsis tp-below-text" style="width: 95%">
                    <span v-b-tooltip.hover.top="job">
                      {{ job }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="tp-side-modal-card-green mt-3"
              v-if="singleCandidateJDResponse.success.length !== 0"
            >
              <div class="ct-table-bold-txt-4">Newly Added</div>
              <div class="tp-text-1">
                This candidate is successfully added to these jobs
              </div>
              <div
                class="tp-second-modal-white-box mt-2"
                :key="i"
                v-for="(job, i) in singleCandidateJDResponse.success"
              >
                <div
                  class="
                    d-flex
                    align-items-center
                    p-2
                    tp-below-text
                    defaultCursor
                  "
                >
                  <div class="ellipsis tp-below-text" style="width: 95%">
                    <span v-b-tooltip.hover.top="job">
                      {{ job }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <div
      class="
        d-flex
        align-items-center
        justify-content-end
        border-top
        pt-2
        pb-3
        pr-4
        bluebtn
      "
    >
      <b-button class="acs-addBtn-modal mt-1" @click="goToAddToTalentPool"
        >Okay</b-button
      >
    </div>
  </b-modal>
</template>
<script>
import {
  thirdPartyImportCheck,
  addCacheCandidates,
} from "../../utils/apiFunctions";
import toast from "../../components/mixin/toast";

export default {
  name: "AddToJDSuccessSingle",
  props: {
    showAddToJDSuccessSingle: Boolean,
    selectedjd: Array,
    candidateSelectedToThirdParty: Object,
  },
  mixins: [toast],
  data() {
    return {
      addjddata: [],
      singleCandidateJDResponse: { success: [], failed: [] },
    };
  },
  methods: {
    async addSingleCandToJD() {
      try {
        this.$store.commit("cvSearchVUEX/setJobIDs", this.selectedjd);
        let candidates = this.candidateSelectedToThirdParty.candidates;
        // Initialize an empty array to store extracted emails
        let emails = [];
        // Loop through each candidate object
        candidates.forEach((candidate) => {
          emails.push(candidate.email);
        });
        let data = {
          emailIDs: emails,
          jobIDs: this.selectedjd,
        };
        const response = await thirdPartyImportCheck(data);
        this.singleCandidateJDResponse = { success: [], failed: [] };

        if (response.status === 200) {
          this.addjddata = response.data.data.jds;
          this.singleCandidateJDResponse.name =
            this.addjddata[0].failed?.[0]?.name ||
            this.addjddata[0].success?.[0]?.name;
          this.singleCandidateJDResponse.email =
            this.addjddata[0].failed?.[0]?.email ||
            this.addjddata[0].success?.[0]?.email;
          this.addjddata.forEach((job) => {
            job.successCount &&
              this.singleCandidateJDResponse.success.push(job.jobName);
            job.failedCount &&
              this.singleCandidateJDResponse.failed.push(job.jobName);
          });
        }
      } catch (error) {
        console.error(error);
        this.errorModal("Something went wrong!");
      }
    },
    async goToAddToTalentPool() {
      try {
        const res = await addCacheCandidates(
          this.candidateSelectedToThirdParty
        );
        if (res.status == 200) {
          const totalSuccessCount = this.addjddata.reduce(
            (total, item) => total + item.successCount,
            0
          );
          // Check if the total sum is zero
          if (totalSuccessCount !== 0) {
            this.$router.push({
              name: "AddFromThirdParty",
              query: {
                fromPage: "addjobs",
              },
            });
          } else {
            this.clearSingleCandToJD();
          }
        }
      } catch (error) {
        console.error("err:", error);
      }
    },
    clearSingleCandToJD() {
      this.singleCandidateJDResponse = { success: [], failed: [] };
      this.$emit("hide-single-cand-jd-modal");
    },
  },
};
</script>
